import { AbstractControl, FormArray, ValidationErrors } from '@angular/forms';
import { SeuFormGroupCalculation } from '@seu-types';
import { isNil } from 'lodash-es';

export function duplicateCombinationValidator(
  abstractForm: AbstractControl
): ValidationErrors | null {
  const formArray = abstractForm as FormArray<SeuFormGroupCalculation>;

  const combinedValuesSet = new Set();

  // go through all groups and check if there are any duplicates
  formArray.controls.forEach((formGroup) => {
    const globalSettingsVal = formGroup.value.globalSettings;
    const interconnectionVersionVal = formGroup.value.interconnectionVersion;

    formGroup.controls.interconnectionVersion.setErrors({ custom: 'Hallo' });

    if (!isNil(globalSettingsVal) && !isNil(interconnectionVersionVal)) {
      const combinedValues = `${globalSettingsVal}_${interconnectionVersionVal}`;

      const isDuplicate = combinedValuesSet.has(combinedValues);
      if (!isDuplicate) {
        combinedValuesSet.add(combinedValues);
      }

      formGroup.setErrors(isDuplicate ? { 'duplicate-input': true } : null);
    }

    formGroup.controls.globalSettings.setErrors(
      isNil(globalSettingsVal)
        ? {
            required: true,
          }
        : null
    );

    formGroup.controls.interconnectionVersion.setErrors(
      isNil(interconnectionVersionVal)
        ? {
            required: true,
          }
        : null
    );
  });

  return null;
}
